// EDEN · app entry. Apply the stored language, resolve the session, then start the router.

import { initLang } from "./i18n";
import { refreshMe } from "./state";
import { initRouter } from "./router";
import { initChrome } from "./chrome";
import { initMobileNav } from "./mobile-nav";
import { initBookReader } from "./book-reader";
import { initDocViewer } from "./doc-viewer";
import { companionTitle, loadVocab, plainText, taskLabel } from "./lesson-data";
import { lightTitle } from "./lesson-refs";
import { inlineSetTitle } from "./sheet-words";

async function boot(): Promise<void> {
  initLang(); // before the first render so every screen paints in the chosen language
  initChrome(); // attach the sidebar's once-only listeners before the first render
  initMobileNav(); // attach the mobile tab bar's once-only "More" sheet listener
  // Teacher Packs, worksheets and any PDF open INSIDE EDEN (teacher review, 15 Oct 2026), never in Adobe. FIRST of the
  // Back-button owners: the viewer can open on top of the Book Reader, and window popstate listeners run in the order
  // they were added, so the phone's Back must reach the top layer (the viewer) before the reader and the router.
  // A worksheet's heading, its exam-task codes, its word-set codes and its companion PDFs in the lesson page's words.
  initDocViewer({
    cleanTitle: (raw) => plainText(lightTitle(raw)),
    taskWords: (code) => taskLabel(code),
    assetTitle: (file) => companionTitle(file),
    setTitles: async (grade) => {
      const reg = await loadVocab(grade);
      // a set with no words is a planning marker: "" keeps its code as written
      return reg ? new Map(reg.sets.map((s) => [s.id, s.words.length ? plainText(inlineSetTitle(s.title)) : ""])) : null;
    },
  });
  initBookReader(); // the Books card's "Open pages" buttons; BEFORE the router, so Back closes the reader first
  await refreshMe();
  initRouter();
}

void boot();
